import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LearningDevelopmentComponent } from './learning-development.component';
import { EmeraldDesignSystemModule } from '@emerald-angular/design-system';
import { EmeraldInputModule } from '@emerald-angular/input';
import { EmeraldIconModule } from '@emerald-angular/icon';
import { EmeraldProgressIndicatorModule } from '@emerald-angular/progress-indicator';

@NgModule({
  declarations: [LearningDevelopmentComponent],
  imports: [
    CommonModule,
    EmeraldDesignSystemModule,
    EmeraldInputModule,
    EmeraldIconModule,
    EmeraldProgressIndicatorModule,
  ],
  exports: [LearningDevelopmentComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LearningDevelopmentModule { }
